import { render, staticRenderFns } from "./HomeRootComponent.vue?vue&type=template&id=131c9e47"
import script from "./HomeRootComponent.vue?vue&type=script&lang=js"
export * from "./HomeRootComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports